import { render, staticRenderFns } from "./jingli.vue?vue&type=template&id=4087d499&scoped=true"
import script from "./jingli.vue?vue&type=script&lang=js"
export * from "./jingli.vue?vue&type=script&lang=js"
import style0 from "./jingli.vue?vue&type=style&index=0&id=4087d499&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4087d499",
  null
  
)

export default component.exports